export enum MaterialStatusEnum {
  MARRIED = 'married',
  LEGALLY_SEPARATED = 'legally_separated',
  DIVORCED = 'divorced',
  NEVER_MARRIED = 'never_married',
  WIDOWED = 'widowed',
}